import { AppAudioBarStyles } from './AppAudioBar.props';
import { IStackStyles, mergeStyleSets, IProcessedStyleSet } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../../common/styles/common.styles';

const audioBarKnobClassName = "audioBarKnobClass";

export const audioBarStackStyles: IStackStyles = {
  root: {
    width: '100%'
  }
};

export const getAudioBarStyles = (currentPercentage: number): IProcessedStyleSet<AppAudioBarStyles> => {
  const styles: AppAudioBarStyles = {
    bar: {
      width: '100%',
      height: '10px',
      background: `linear-gradient(to right, ${AppLayoutSettings.getAppColorContainer().linkColor.value} ${currentPercentage}%, ${AppLayoutSettings.getAppColorContainer().progressBackground.value} 0)`,
      selectors: {
        [`:hover`]: {
          cursor: 'pointer'
        },
        [`:hover .${audioBarKnobClassName}`]: {
          visibility: 'visible'
        }
      }
    },
    timeContainer: {
      fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
      display: 'flex',
      width: '100%',
      alignContent: 'stretch',
      fontSize: AppLayoutSettings.AppFontSize.mediumFontSizePx,
      padding: '4px 0px 0px 0px',
      color: AppLayoutSettings.getAppColorContainer().mediumLabelColor.value
    },
    knob: [
      audioBarKnobClassName,
      {
        position: 'relative',
        height: '10px',
        width: '10px',
        background: AppLayoutSettings.getAppColorContainer().whiteColor.value,
        borderRadius: '50%',
        visibility: 'hidden',
      }
    ],
    duration: {
      marginLeft: 'auto'
    }
  };

  return mergeStyleSets(styles);
};
